// @ts-check

/**
 * @file System-test browser helper for native APK bridge configuration.
 */

import SystemTestBrowserHelper from "system-testing/build/system-test-browser-helper.js"

import {expoPublicEnv} from "../shared/expo-public-env"
import {registerBackendModelClassesWithScoundrel} from "./register-backend-model-classes"

/** Browser helper that reads native-embedded AwesomeTasks system-test bridge settings. */
export default class NativeSystemTestBrowserHelper extends SystemTestBrowserHelper {
  /**
   * Makes native Scoundrel readiness include app-owned class registration.
   * @returns {Promise<void>} Resolves once the exact connected client is registered.
   */
  async waitForScoundrelStarted() {
    await super.waitForScoundrelStarted()
    registerBackendModelClassesWithScoundrel(super.getScoundrel())
  }

  /**
   * Resolves the host used for system-test WebSocket connections.
   * @returns {string} Host used for system-test WebSocket connections.
   */
  getSystemTestHost() {
    return expoPublicEnv("EXPO_PUBLIC_SYSTEM_TEST_HOST") || super.getSystemTestHost()
  }

  /**
   * Resolves the client or Scoundrel WebSocket port.
   * @param {string} parameterName System-testing query parameter name.
   * @param {number} fallback Default port from system-testing.
   * @returns {number} Configured port.
   */
  getSystemTestPort(parameterName, fallback) {
    const configuredValue = systemTestPortValue(parameterName)
    const parsedValue = Number(configuredValue)

    if (Number.isInteger(parsedValue) && parsedValue > 0) return parsedValue

    return super.getSystemTestPort(parameterName, fallback)
  }
}

/**
 * Maps system-testing query parameter names to embedded Expo public env values.
 * @param {string} parameterName System-testing query parameter name.
 * @returns {string | undefined} Embedded port value.
 */
function systemTestPortValue(parameterName) {
  switch (parameterName) {
    case "systemTestClientWsPort":
      return expoPublicEnv("EXPO_PUBLIC_SYSTEM_TEST_CLIENT_WS_PORT")
    case "systemTestScoundrelPort":
      return expoPublicEnv("EXPO_PUBLIC_SYSTEM_TEST_SCOUNDREL_PORT")
    default:
      return undefined
  }
}
